<script>
/* COMPOSANTS */
import AkDatatablePagination from '@components/v2/general/AkDatatablePagination.vue';

/* MIXINS */
import utilsMixin from '@mixins/utilsMixin';

/* SERVICES */
import housekeeperAccommodationService from '@services/housekeeperAccommodationService';
import PrestationBadge from '@components/general/PrestationBadge.vue';

export default {
  components: {PrestationBadge, AkDatatablePagination},
  mixins: [utilsMixin],
  props: {
    modelValue: {
      required: true,
    },
  },
  emits: ['error'],
  data() {
    return {
      list: undefined,
    };
  },
  mounted() {
    this.refresh();
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
    },
  },
  methods: {
    refresh() {
      housekeeperAccommodationService
        .housekeeperAccommodationsHistory(this.currentValue.id)
        .then((data) => {
          this.list = data;
        })
        .catch((e) => {
          this.$emit('error', e);
        });
    },
  },
};
</script>

<template>
  <AkDatatablePagination :value="list" :lazy="false" :loading="list == null">
    <template #empty> {{ this.$t('housekeeper.accommodations_history_empty') }} </template>
    <Column :header="$t('accommodation.short')" :sortable="true" sort-field="accommodationName">
      <template #body="slotProps">
        <router-link :to="{name: 'accommodationPage', params: {accommodationId: slotProps.data.accommodationId}}">
          {{ slotProps.data.accommodationName }}
        </router-link>
      </template>
    </Column>
    <Column :header="$t('prestation.list')">
      <template #body="slotProps">
        <template v-if="slotProps.data.prestationTypes?.length > 0">
          <div
            v-for="mission in slotProps.data.prestationTypes"
            :key="mission"
            class="flex justify-start items-center gap-4">
            <PrestationBadge :type="mission" />
          </div>
        </template>
        <template v-else>{{ this.$t('prestation.empty') }}</template>
      </template>
    </Column>
    <Column :header="$t('date_start')" :sortable="true" sort-field="dateStart">
      <template #body="slotProps">
        {{ this.formatDateIfNeeded(slotProps.data.dateStart) }}
      </template>
    </Column>
    <Column :header="$t('date_end')" :sortable="true" sort-field="dateEnd">
      <template #body="slotProps">
        {{ this.formatDateIfNeeded(slotProps.data.dateEnd) }}
      </template>
    </Column>
    <Column :header="$t('created_by')">
      <template #body="slotProps">
        {{ slotProps.data.createdBy }}
      </template>
    </Column>
    <Column :header="$t('updated_by')">
      <template #body="slotProps">
        {{ slotProps.data.updatedBy }}
      </template>
    </Column>
  </AkDatatablePagination>
</template>
